module.exports = __webpack_public_path__ + "static/media/JordanBonagura.f7581639.png";